import React from 'react';
import { Controller, useForm } from 'react-hook-form';

import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';

import CustomHeader from '../file/CustomHeader';
import InputErrorMessage from 'components/UI/InputErrorMessage/InputErrorMessage';

import { useFileManagerContext } from 'modules/FileManagerV2/context/FileManagerContext';
import { useFileMutations } from 'modules/FileManagerV2/hooks/api/useFileMutations';
import { useToast } from 'context/ToastContext';
import { toastConstant } from 'constants/toastmessage';
import TextSnippetWrapper from 'components/TextSnippetWrapper';

function CreateFolderModal() {
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm();

  const { modals, isLeadFileManager, isFirmDocuments, caseDetails, handleGetFiles, pageLimit, breadCrumbs } = useFileManagerContext();
  const { showCreateFolderModal, setShowCreateFolderModal } = modals;
  const { addToast } = useToast();
  const { createFile } = useFileMutations();

  const createFolder = async (data) => {
    let breadCrumbsLength = breadCrumbs?.length;
    const folderName = data.folderName.trim();

    // data.is_lead = isLeadFileManager;

    const finalPayload = {
      folderName,
      type: 'folder',
      folder_id: breadCrumbs[breadCrumbsLength - 1]?.value || '',
      display_name: folderName,
      case_id: isFirmDocuments ? undefined : caseDetails?.case_id,
    };

    // Custom JSON stringify that preserves undefined values
    const jsonString = JSON.stringify(finalPayload, (key, value) => {
      if (value !== undefined) {
        return value;
      }
      return 'undefined';
    });

    // Parse back to get the object with 'undefined' strings
    const payloadWithUndefined = JSON.parse(jsonString);

    let obj = {
      data: payloadWithUndefined,
      is_lead: isLeadFileManager,
      isFirmDocuments: isFirmDocuments,
    };

    try {
      await createFile(obj);
      // handleGetFiles(pageLimit, breadCrumbs[breadCrumbsLength - 1]?.value);
      setShowCreateFolderModal(false);
      addToast(false, toastConstant.toasterType.SUCCESS, toastConstant.api.SUCCESS, toastConstant.message.FOLDER_CREATED);
    } catch (error) {
      const { data } = error?.response || {};
      const apiMessage = typeof data === 'string' ? data : data?.error || data?.message || '';
      addToast(false, toastConstant.toasterType.ERROR, toastConstant.api.ERROR, apiMessage || toastConstant.message.FOLDER_CREATE_FAILED);
    }
  };

  const footer = (
    <div className="footer-btn">
      <Button label="Cancel" onClick={() => setShowCreateFolderModal(false)} className="p-button p-button-secondary outline" />
      <Button label="Create" onClick={handleSubmit(createFolder)} className="p-button p-button-secondary me-0" />
    </div>
  );

  return (
    <Dialog
      className="rounded-radius FM-popup new-task-popup"
      header={<CustomHeader title="" onHide={() => setShowCreateFolderModal(false)} />}
      footer={footer}
      visible={showCreateFolderModal}
      style={{ width: '40vw' }}
      modal
      onHide={() => setShowCreateFolderModal(false)}
      closable={false}
    >
      <div className="modal-heading F-size16 text-bold mb-4">Create Folder</div>
      <Controller
        name="folderName"
        control={control}
        defaultValue={''}
        rules={{
          required: 'Required',
          validate: (value) => (value || '').trim().length > 0 || 'Required',
        }}
        render={({ field }) => (
          <TextSnippetWrapper
            type="text"
            {...field}
            onChange={(e) => field.onChange(e)}
            placeholder="Folder Name"
            className="input-shadow w-100 mt-2"
          />
        )}
      />
      {errors?.folderName && <InputErrorMessage>Required</InputErrorMessage>}
    </Dialog>
  );
}

export default CreateFolderModal;
